import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../Webservices/api';

// const API_URL = 'http://localhost:3001/api';

export const fetchSections = createAsyncThunk(
  "sections/fetchSections",
  async (_, thunkAPI) => {
    const state = thunkAPI.getState();

    const schoolId = state.masterData.school_id;
    const userId = state.authSlice?.user?.id;
    const isIndividualLogin = state.authSlice?.user.roles === 'teacher' || state.authSlice?.user.roles === 'guest_user';


    const response = await api.get(
      `/sections/${schoolId}`,
      {
        params: userId && isIndividualLogin ? { user_id: userId } : {},
      }
    );

    return response.data;
  }
);

export const createSection = createAsyncThunk(
  'sections/createSection',
  async (sectionData) => {
    const response = await api.post(`/sections`, sectionData);
    return response.data;
  }
);

export const updateSection = createAsyncThunk(
  'sections/updateSection',
  async ({ id, data }) => {
    const response = await api.put(`/sections/${id}`, data);
    return response.data;
  }
);

export const deleteSection = createAsyncThunk(
  'sections/deleteSection',
  async ({id,user_id}) => {
    await api.delete(`/sections/${id}/${user_id}`);
    return id;
  }
);

const sectionSlice = createSlice({
  name: 'sections',
  initialState: {
    sections: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSections.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchSections.fulfilled, (state, action) => {
        state.loading = false;
        state.sections = action.payload;
      })
      .addCase(fetchSections.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(createSection.fulfilled, (state, action) => {
        state.sections.push(action.payload);
      })
      .addCase(updateSection.fulfilled, (state, action) => {
        const index = state.sections.findIndex(section => section.section_id === action.payload.section_id);
        if (index !== -1) {
          state.sections[index] = action.payload;
        }
      })
      .addCase(deleteSection.fulfilled, (state, action) => {
        state.sections = state.sections.filter(section => section.section_id !== action.payload);
      });
  },
});

export default sectionSlice.reducer;
